<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="details-container">
    <div class="container">
        <h1>Vamos publicar</h1>
        <p class="subtitle">
            Conte-nos sobre um pouco mais sobre seu livro
        </p>
        <ng-container *ngIf="isLoading; else mainContent">
            <div class="spinner-container">
                <mat-spinner></mat-spinner>
            </div>
        </ng-container>
        <ng-template #mainContent>
            <form [formGroup]="model" (ngSubmit)="onSubmit()">
                <div class="fields-row">
                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Título</mat-label>
                        <input matInput formControlName="bookTitle" [readonly]="true" [disabled]="true" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Subtítulo</mat-label>
                        <input matInput formControlName="bookSubtitle" [readonly]="true" [disabled]="true">
                    </mat-form-field>
                </div>

                <div class="fields-row">
                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Edição</mat-label>
                        <input matInput formControlName="versionName">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Nome da coleção</mat-label>
                        <input matInput formControlName="collectionName">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Volume / número da coleção</mat-label>
                        <input matInput formControlName="volumeName">
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline" class="synopsis-field">
                    <mat-label>Sinópse (min. 500 e máx. 800 caracteres)</mat-label>
                    <textarea matInput formControlName="synopsis" rows="4"></textarea>
                    <mat-hint>
                        {{ model.get('synopsis')?.value?.length || 0 }}/800
                    </mat-hint>
                </mat-form-field>

                <h2 class="section-title">Autores</h2>
                <p class="subtitle">Todos os autores envolvidos na construção do livro, incluindo o autor principal</p>

                <div formArrayName="authors">
                    <div class="authors-row" *ngFor="let authorCtrl of authors.controls; let i = index">
                        <mat-form-field appearance="outline" class="author-field">
                            <mat-label>Autor {{i == 0 ? "principal" : ""}}</mat-label>
                            <input matInput [formControlName]="i">
                        </mat-form-field>
                        <button type="button" class="icon-btn btn-green" (click)="addAuthor()">
                            <mat-icon>add</mat-icon>
                        </button>
                        <button type="button" class="icon-btn btn-red" *ngIf="authors.length > 1"
                            (click)="removeAuthor(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>

                <h2 class="section-title">Bio do autor (orelha da contracapa)</h2>
                <p class="subtitle">Biografia e foto do autor que ficam na orelha da contracapa</p>
                <div class="author-bio-row">
                    <!-- Upload e preview de foto (2/3) -->
                    <div class="author-photo-area">
                        <label class="photo-upload-label">
                            <div class="photo-drop-area" (drop)="onAuthorPhotoDrop($event)"
                                (dragover)="onAuthorPhotoDragOver($event)">
                                <ng-container *ngIf="!authorPhotoPreview">
                                    <span>Arraste a foto do autor aqui<br>ou</span>
                                    <button type="button" mat-raised-button (click)="fileInput.click()">Selecionar
                                        foto</button>
                                    <input type="file" #fileInput accept="image/*"
                                        (change)="onAuthorPhotoSelected($event)" hidden />
                                </ng-container>
                                <ng-container *ngIf="authorPhotoPreview">
                                    <img [src]="authorPhotoPreview || ''" alt="Foto do Autor" [ngClass]="{
                                                    'photo-square': model.get('idPhotoShape')?.value === 1,
                                                    'photo-round': model.get('idPhotoShape')?.value === 2
                                                }" class="author-photo-preview" />
                                    <button mat-stroked-button color="warn" type="button"
                                        (click)="authorPhotoPreview=null; model.patchValue({authorPhotoBase64: ''}); cdr.markForCheck()">
                                        Remover
                                    </button>
                                </ng-container>
                            </div>
                        </label>
                        <div class="photo-shape-options">
                            <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 1"
                                (click)="model.patchValue({ idPhotoShape: 1 })" tabindex="0" role="button"
                                aria-label="Foto quadrada">
                                <span class="icon-label">
                                    <svg width="28" height="28">
                                        <rect x="4" y="4" width="20" height="20" rx="5" fill="none" stroke="#28a745"
                                            stroke-width="3" />
                                    </svg>
                                    <span>Quadrada</span>
                                </span>
                            </div>
                            <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 2"
                                (click)="model.patchValue({ idPhotoShape: 2 })" tabindex="0" role="button"
                                aria-label="Foto redonda">
                                <span class="icon-label">
                                    <svg width="28" height="28">
                                        <circle cx="14" cy="14" r="10" fill="none" stroke="#28a745" stroke-width="3" />
                                    </svg>
                                    <span>Redonda</span>
                                </span>
                            </div>
                        </div>

                    </div>
                    <!-- Campo Biografia (1/3) -->
                    <div class="author-bio-area">
                        <mat-form-field appearance="outline" class="bio-field">
                            <mat-label>Biografia do autor (máx. 4000 caracteres)</mat-label>
                            <textarea matInput formControlName="authorBio" rows="8" maxlength="4000"></textarea>
                            <mat-hint align="end">{{ model.get('authorBio')?.value?.length || 0 }}/4000</mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <h2 class="section-title">Epígrafe (orelha da capa)</h2>
                <p class="subtitle">Epígrafe, texto para a orelha da capa</p>
                <mat-form-field appearance="outline" class="synopsis-field">
                    <mat-label>Epígrafe (máx. 250 caracteres)</mat-label>
                    <textarea matInput formControlName="preface" rows="4"></textarea>
                    <mat-hint>
                        {{ model.get('preface')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>

                <h2 class="section-title">Outros dados</h2>
                <p class="subtitle">Demais informações</p>
                <!-- <div class="fields-row">
                <mat-form-field appearance="outline" class="field">
                    <mat-label>Idioma</mat-label>
                    <mat-select formControlName="language">
                        <mat-option *ngFor="let item of listLanguages" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->
                <div class="fields-row">
                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Categoria primária</mat-label>
                        <mat-select formControlName="primaryCategory">
                            <mat-option [value]="''" disabled selected>Selecione</mat-option>

                            <ng-container *ngFor="let opt of primaryOptions; trackBy: trackByOption">
                                <mat-option *ngIf="opt.isHeader" disabled><b
                                        style="color: #28a745;background: #f6f6f6;">{{ opt.label }}</b></mat-option>
                                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory"
                                    style="margin-left: 4px; font-size: 14px;">{{ opt.label }}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Categoria secundária</mat-label>
                        <mat-select formControlName="secondaryCategory">
                            <mat-option [value]="''" disabled selected>Selecione</mat-option>

                            <ng-container *ngFor="let opt of secondaryOptions; trackBy: trackByOption">
                                <mat-option *ngIf="opt.isHeader" disabled>{{ opt.label }}</mat-option>
                                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory">{{ opt.label }}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>


                <!-- <div class="fields-row">
                <mat-form-field appearance="outline" class="field">
                    <mat-label>Faixa etária</mat-label>
                    <mat-select formControlName="ageRange">
                        <mat-option *ngFor="let range of listAgeRanges" [value]="range.id">
                            {{ range.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->

                <div class="details-actions">
                    <!-- <div class="back-btn" (click)="voltar()">Voltar</div> -->
                    <button class="continue-btn" type="submit">Submeter</button>
                </div>

            </form>
        </ng-template>
    </div>
</div>

<app-footer></app-footer>